import './_product-carousel.scss';
import component from './product-carousel';

export default component;
